/* Mis mascotas — la página del cliente dentro la tienda.
 *
 * QUÉ HACE. Las tarjetas ya están pintadas por Liquid cuando llega este archivo: no
 * se vuelven a dibujar salvo que algo cambie. Lo que hace falta del servidor son los
 * identificadores, los campos que el metafield no deja leer y, sobre todo, EL
 * VOCABULARIO: las opciones de alergias y necesidades salen del catálogo, nunca de una
 * lista escrita aquí. Una lista escrita aquí se desvía, y cuando se desvía el cliente
 * guarda palabras que el catálogo no conoce: la alergia deja de excluir nada y la
 * siguiente vez el área de cliente la borra por no reconocerla.
 *
 * ESCRIBIR. Todo pasa por /apps/onlyfresh/pets, en ruta relativa. Shopify firma la
 * llamada y le mete dentro quién está conectado, así que desde aquí no se manda ningún
 * identificador de cliente. La ruta es relativa a propósito: con ocho mercados con
 * prefijo, un POST a un dominio que redirige se convierte en GET y pierde el cuerpo,
 * y entonces la página diría "Guardado" sin haber guardado nada.
 *
 * LA FOTO. El navegador la reduce antes de subirla: el cuerpo de una función en Vercel
 * no puede pasar de 4,5 MB y una foto de móvil sale de ahí ella sola.
 *
 * LOS TEXTOS. Están todos en T, aquí abajo, y hoy solo en español. Cuando se traduzcan
 * se mueven a los locales del tema y T se llena desde Liquid: por eso están juntos.
 */
(function () {
  "use strict";

  var raiz = document.querySelector("[data-ofm]");
  if (!raiz || !raiz.getAttribute("data-logged")) return;

  var T = {
    foto: "Su foto",
    fotoElegir: "Elegir una foto",
    fotoAyuda: "Si pesa mucho la reducimos nosotros.",
    fotoSubiendo: "Subiendo la foto, {n}%",
    fotoHecha: "Foto guardada.",
    quien: "Quién es",
    nombre: "Nombre",
    peso: "Peso en kilos",
    nacimiento: "Fecha de nacimiento",
    raza: "Raza",
    razaAyuda: "De aquí sacamos cuánto pesará de adulto, que es lo que manda mientras crece.",
    sexo: "Sexo",
    sexoNo: "Prefiero no decirlo",
    hembra: "Hembra",
    macho: "Macho",
    como: "Cómo está",
    actividad: "Nivel de actividad",
    actBaja: "Tranquilo",
    actMedia: "Normal",
    actAlta: "Muy activo",
    cuerpo: "Condición física",
    cuerpoDelgado: "Delgado",
    cuerpoIdeal: "En su peso",
    cuerpoAlgo: "Con algún kilo de más",
    cuerpoObeso: "Obeso",
    cuerpoAyuda: "Con kilos de más le calculamos la ración por la columna reducida.",
    esterilizado: "Está esterilizado o castrado",
    noPuede: "Qué no puede comer",
    noPuedeAyuda: "Toca para marcarlo. Lo tachado es lo que le quitamos del catálogo.",
    cuidar: "Qué hay que cuidarle",
    guardar: "Guardar",
    cerrar: "Cerrar",
    guardado: "Guardado.",
    gestionar: "Gestionar el plan",
    editar: "Editar su ficha",
    comeAlDia: "Come al día",
    sacoDura: "Su saco dura",
    proxima: "Próxima entrega",
    dias: "días",
    sinPlan: "Todavía sin plan",
    verPlanes: "Ver lo que le va bien",
    salud: "Su salud",
    noPuedeCorto: "No puede comer",
    cuidarCorto: "Hay que cuidarle",
    esterilizada: "Esterilizada",
    esterilizadoM: "Esterilizado",
    nada: "Nada por ahora.",
    gustos: "Lo que le gusta",
    actividad2: "Actividad",
    cuerpo2: "Condición física",
    volver: "Volver a la ficha",
    nueva: "Una mascota nueva",
    especie: "Perro o gato",
    perro: "Perro",
    gato: "Gato",
    crear: "Crear la ficha",
    creada: "Ficha creada. Ahora puedes ponerle la foto.",
    borrar: "Eliminar esta ficha",
    borrarSeguro: "Sí, eliminar a {name}",
    borrarNo: "Dejarlo como está",
    borrada: "Ficha eliminada.",
    cargando: "Un momento, estamos cargando sus datos.",
    errGuardar: "No hemos podido guardar.",
    errNombre: "Nos falta el nombre.",
    errPeso: "El peso tiene que ser un número entre 0,5 y 120 kg.",
    errFecha: "Esa fecha no puede ser: revisa el día de nacimiento.",
    errFoto: "No hemos podido guardar la foto.",
    errFotoGrande: "La foto es demasiado grande, aunque la hayamos reducido.",
    errFotoTipo: "Ese formato de imagen no nos sirve. Prueba con un JPG o un PNG.",
    errBorrar: "No hemos podido eliminarla.",
    errTope: "Has llegado al máximo de fichas. Escríbenos y te ayudamos.",
    errRed: "Parece que no hay conexión. Inténtalo otra vez."
  };

  var URL_PETS = raiz.getAttribute("data-pets-url") || "/apps/onlyfresh/pets";
  var lista = raiz.querySelector("[data-ofm-list]");
  var panel = raiz.querySelector("[data-ofm-panel]");
  var aviso = raiz.querySelector("[data-ofm-aviso]");
  var btnNueva = raiz.querySelector("[data-ofm-nueva]");

  var ANIMALES = [];
  var VOCAB = null;
  var TOPE = 12;
  var abierto = null;
  var cargado = false;

  /* Los mensajes se quedan siempre en el árbol: un aria-live que nace con hidden no
     anuncia nada la primera vez que se llena. Se vacía el texto, no el elemento. */
  function decir(texto, mal) {
    if (!aviso) return;
    aviso.textContent = texto || "";
    aviso.classList.toggle("is-mal", !!mal);
    aviso.classList.toggle("is-vacio", !texto);
  }

  function conCodigo(codigo) {
    var mapa = {
      name_required: T.errNombre,
      invalid_weight: T.errPeso,
      invalid_birthdate: T.errFecha,
      photo_too_large: T.errFotoGrande,
      photo_type_not_supported: T.errFotoTipo,
      too_many_pets: T.errTope
    };
    return mapa[codigo] || T.errGuardar;
  }

  /* redirect: "error" no es paranoia: un POST redirigido se convierte en GET, pierde
     el cuerpo y el servidor contesta la lista con ok: true. La página creería haber
     guardado. Mejor un fallo ruidoso. */
  function llamar(cuerpo) {
    return fetch(URL_PETS, {
      method: "POST",
      redirect: "error",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().catch(function () {
        return { ok: false, error: "respuesta_ilegible" };
      });
    });
  }

  function el(tag, clase, texto) {
    var n = document.createElement(tag);
    if (clase) n.className = clase;
    if (texto != null) n.textContent = texto;
    return n;
  }

  /* Las opciones vienen del catálogo. La etiqueta es el valor: el vocabulario del
     catálogo ya está en el idioma de la tienda, y traducirlo aquí sería inventarse
     una segunda lista. */
  function opciones(valores) {
    return (valores || []).map(function (v) {
      return { v: v, label: v };
    });
  }

  /* ── Campos ──────────────────────────────────────────────────────────────── */

  function campo(etiqueta, nodo, ancho, ayuda) {
    var caja = el("div", "ofm__campo" + (ancho ? " ofm__campo--ancho" : ""));
    nodo.id = "ofm-campo-" + (campo.n = (campo.n || 0) + 1);
    var lab = el("label", "ofm__label", etiqueta);
    lab.setAttribute("for", nodo.id);
    caja.appendChild(lab);
    caja.appendChild(nodo);
    if (ayuda) {
      var a = el("p", "ofm__ayuda", ayuda);
      a.id = nodo.id + "-ayuda";
      nodo.setAttribute("aria-describedby", a.id);
      caja.appendChild(a);
    }
    return caja;
  }

  function texto(valor, tipo) {
    var i = document.createElement("input");
    i.type = tipo || "text";
    i.className = "ofm__input";
    i.value = valor == null ? "" : String(valor);
    return i;
  }

  function seleccion(valor, opts) {
    var s = document.createElement("select");
    s.className = "ofm__select";
    opts.forEach(function (o) {
      var op = document.createElement("option");
      op.value = o.v;
      op.textContent = o.label;
      if (o.v === valor) op.selected = true;
      s.appendChild(op);
    });
    return s;
  }

  function pastillas(opts, elegidas, gusto, leyenda) {
    var caja = el("fieldset", "ofm__fieldset");
    var leg = el("legend", "ofm__h2", leyenda);
    caja.appendChild(leg);
    var fila = el("div", "ofm__pills");
    var estado = (elegidas || []).slice();
    opts.forEach(function (o) {
      var b = el("button", "ofm__pill" + (gusto ? " ofm__pill--gusto" : ""), o.label);
      b.type = "button";
      var on = estado.indexOf(o.v) !== -1;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", String(on));
      b.addEventListener("click", function () {
        var i = estado.indexOf(o.v);
        if (i === -1) estado.push(o.v);
        else estado.splice(i, 1);
        var ahora = estado.indexOf(o.v) !== -1;
        b.classList.toggle("is-on", ahora);
        b.setAttribute("aria-pressed", String(ahora));
      });
      fila.appendChild(b);
    });
    caja.appendChild(fila);
    caja.leer = function () {
      return estado.slice();
    };
    return caja;
  }

  /* ── La foto ─────────────────────────────────────────────────────────────── */

  function reducir(file) {
    var MEDIDAS = [1600, 1200, 900];
    var CALIDAD = [0.82, 0.72, 0.68];
    var LIMITE = 3 * 1024 * 1024;

    return new Promise(function (listo, falla) {
      if (!window.createImageBitmap || !file.type || file.type.indexOf("image/") !== 0) {
        return falla(new Error("no_imagen"));
      }
      createImageBitmap(file, { imageOrientation: "from-image" }).then(function (bm) {
        var paso = 0;
        function intenta() {
          var max = MEDIDAS[paso];
          var escala = Math.min(1, max / Math.max(bm.width, bm.height));
          var w = Math.round(bm.width * escala);
          var h = Math.round(bm.height * escala);
          var lienzo = document.createElement("canvas");
          lienzo.width = w;
          lienzo.height = h;
          lienzo.getContext("2d").drawImage(bm, 0, 0, w, h);
          lienzo.toBlob(
            function (blob) {
              if (!blob) return falla(new Error("no_blob"));
              if (blob.size <= LIMITE || paso >= MEDIDAS.length - 1) {
                var lector = new FileReader();
                lector.onload = function () {
                  var s = String(lector.result || "");
                  listo({ base64: s.slice(s.indexOf(",") + 1), mimeType: "image/jpeg" });
                };
                lector.onerror = function () {
                  falla(new Error("no_legible"));
                };
                lector.readAsDataURL(blob);
                return;
              }
              paso += 1;
              intenta();
            },
            "image/jpeg",
            CALIDAD[paso]
          );
        }
        intenta();
      }, falla);
    });
  }

  /* XHR y no fetch: fetch no sabe decir cuánto lleva subido, y es justo lo que hace
     falta enseñar. Se para en el 95 porque el resto lo tarda el servidor en guardar. */
  function subir(cuerpo, alAvanzar) {
    return new Promise(function (listo, falla) {
      var x = new XMLHttpRequest();
      x.open("POST", URL_PETS, true);
      x.setRequestHeader("Content-Type", "application/json");
      if (x.upload && alAvanzar) {
        x.upload.onprogress = function (e) {
          if (e.lengthComputable) alAvanzar(Math.min(95, Math.round((e.loaded / e.total) * 95)));
        };
      }
      x.onload = function () {
        try {
          listo(JSON.parse(x.responseText));
        } catch (e) {
          falla(new Error("respuesta_ilegible"));
        }
      };
      x.onerror = function () {
        falla(new Error("sin_red"));
      };
      x.send(JSON.stringify(cuerpo));
    });
  }

  /* ── La ficha ────────────────────────────────────────────────────────────── */

  /** La línea de debajo del nombre, construida de los campos que hay. */
  function resumen(pet) {
    var trozos = [];
    if (pet.breed) trozos.push(pet.breed);
    if (pet.weightKg) trozos.push(String(pet.weightKg).replace(".", ",") + " kg");
    if (pet.birthdate) {
      var meses = Math.floor((Date.now() - new Date(pet.birthdate + "T12:00:00Z").getTime()) / 2629746000);
      if (meses >= 0) {
        trozos.push(meses < 24 ? meses + " meses" : Math.floor(meses / 12) + " años");
      }
    }
    return trozos.join(" · ");
  }

  /** I tre numeri in alto. Senza piano non si inventano: la riga non si disegna. */
  function numeri(pet) {
    var plan = (pet.plans || []).filter(function (p) { return p && p.before; })[0];
    if (!plan) return null;
    var caja = el("div", "ofm__cifras");
    function dato(eti, val) {
      var d = el("div", "ofm__cifra");
      d.appendChild(el("p", "ofm__cifralab", eti));
      d.appendChild(el("p", "ofm__cifraval", val));
      caja.appendChild(d);
    }
    dato(T.comeAlDia, Math.round(plan.before.gramsPerDay) + " g");
    dato(T.sacoDura, Math.round(plan.before.bagDurationDays) + " " + T.dias);
    dato(T.proxima, fecha(plan.nextBillingDate));
    return caja;
  }

  /** Giorno in formato europeo, che e' quello che si usa in tutta la casa. */
  function fecha(iso) {
    if (!iso) return "—";
    var d = new Date(iso);
    if (isNaN(d.getTime())) return "—";
    function dd(n) { return (n < 10 ? "0" : "") + n; }
    return dd(d.getDate()) + "/" + dd(d.getMonth() + 1) + "/" + d.getFullYear();
  }

  function etiquetas(valores, clase) {
    var f = el("div", "ofm__pills");
    (valores || []).forEach(function (v) {
      f.appendChild(el("span", "ofm__tag" + (clase ? " " + clase : ""), v));
    });
    return f;
  }

  /**
   * La ficha, en lectura. Es lo primero que ve el cliente: quien abre esta pagina
   * casi siempre viene a MIRAR (cuanto come, cuando llega el saco), no a escribir.
   * El formulario esta detras de "Editar su ficha".
   */
  function dibujarFicha(pet) {
    panel.innerHTML = "";
    panel.hidden = false;

    var arriba = el("div", "ofm__fichatop");
    var foto = el("span", "ofm__fichafoto");
    if (pet.photoUrl) {
      var im = document.createElement("img");
      im.src = pet.photoUrl;
      im.alt = "";
      foto.appendChild(im);
    } else {
      foto.appendChild(el("span", "ofm__inicial", (pet.name || "?").charAt(0).toUpperCase()));
    }
    var cab = el("div", "ofm__fichacab");
    cab.appendChild(el("h2", "ofm__fichanombre", pet.name || ""));
    cab.appendChild(el("p", "ofm__fichalinea", resumenLargo(pet)));
    var acc = el("div", "ofm__acciones");
    var plan = (pet.plans || [])[0];
    var bPlan = el("a", "ofm__btn", plan ? T.gestionar : T.verPlanes);
    bPlan.href = plan ? (raiz.getAttribute("data-account-url") || "/account") : "/";
    var bEdit = el("button", "ofm__btn ofm__btn--claro", T.editar);
    bEdit.type = "button";
    bEdit.addEventListener("click", function () { dibujarModulo(pet); });
    acc.appendChild(bPlan);
    acc.appendChild(bEdit);
    cab.appendChild(acc);
    arriba.appendChild(foto);
    arriba.appendChild(cab);
    panel.appendChild(arriba);

    var cifras = numeri(pet);
    if (cifras) panel.appendChild(cifras);

    var dos = el("div", "ofm__dos");

    var sal = el("section", "ofm__bloque");
    sal.appendChild(el("h3", "ofm__h2", T.salud));
    sal.appendChild(el("p", "ofm__label", T.noPuedeCorto));
    if ((pet.allergies || []).length) sal.appendChild(etiquetas(pet.allergies, "ofm__tag--no"));
    else sal.appendChild(el("p", "ofm__ayuda", T.nada));
    sal.appendChild(el("p", "ofm__label ofm__label--sep", T.cuidarCorto));
    if ((pet.needs || []).length) sal.appendChild(etiquetas(pet.needs));
    else sal.appendChild(el("p", "ofm__ayuda", T.nada));
    dos.appendChild(sal);

    var gus = el("section", "ofm__bloque");
    gus.appendChild(el("h3", "ofm__h2", T.gustos));
    if ((pet.preferredProteins || []).length) gus.appendChild(etiquetas(pet.preferredProteins, "ofm__tag--si"));
    else gus.appendChild(el("p", "ofm__ayuda", T.nada));
    function riga(eti, val) {
      var r2 = el("div", "ofm__riga");
      r2.appendChild(el("span", null, eti));
      r2.appendChild(el("b", null, val));
      gus.appendChild(r2);
    }
    riga(T.actividad2, { low: T.actBaja, medium: T.actMedia, high: T.actAlta }[pet.activityLevel] || "—");
    riga(T.cuerpo2, { underweight: T.cuerpoDelgado, ideal: T.cuerpoIdeal, overweight: T.cuerpoAlgo, obese: T.cuerpoObeso }[pet.bodyCondition] || "—");
    dos.appendChild(gus);

    panel.appendChild(dos);
    marcarAbierta(numero(pet.id));
  }

  /** La riga sotto il nome nella ficha: razza, sesso, sterilizzato, eta'. */
  function resumenLargo(pet) {
    var t = [];
    if (pet.breed) t.push(pet.breed);
    if (pet.sex) t.push(pet.sex === "female" ? T.hembra : T.macho);
    if (pet.neutered) t.push(pet.sex === "female" ? T.esterilizada : T.esterilizadoM);
    var e = edad(pet.birthdate);
    if (e) t.push(e);
    return t.join(" · ");
  }

  function edad(iso) {
    if (!iso) return "";
    var meses = Math.floor((Date.now() - new Date(iso + "T12:00:00Z").getTime()) / 2629746000);
    if (!(meses >= 0)) return "";
    return meses < 24 ? meses + " meses" : Math.floor(meses / 12) + " años";
  }

  function dibujarModulo(pet) {
    panel.innerHTML = "";
    panel.hidden = false;

    var arriba = el("div", "ofm__fichatop");
    var foto = el("span", "ofm__fichafoto");
    if (pet.photoUrl) {
      var img = document.createElement("img");
      img.src = pet.photoUrl;
      img.alt = "";
      foto.appendChild(img);
    } else {
      foto.appendChild(el("span", "ofm__inicial", (pet.name || "?").charAt(0).toUpperCase()));
    }
    var cabecera = el("div");
    cabecera.appendChild(el("h2", "ofm__fichanombre", pet.name || ""));
    cabecera.appendChild(el("p", "ofm__fichalinea", resumen(pet)));
    arriba.appendChild(foto);
    arriba.appendChild(cabecera);
    panel.appendChild(arriba);

    /* La foto primero: es lo único que no se puede dar desde la página de producto,
       así que es la razón por la que la mayoría abre esta ficha. */
    var gFoto = el("section", "ofm__grupo");
    gFoto.appendChild(el("h3", "ofm__h2", T.foto));
    var file = document.createElement("input");
    file.type = "file";
    file.accept = "image/*";
    file.className = "ofm__file";
    file.id = "ofm-foto-" + (dibujarFicha.n = (dibujarFicha.n || 0) + 1);
    // L'etichetta fa da bottone: il controllo nativo non si puo' vestire e il suo
    // testo lo scrive il browser, quindi su un browser in inglese esce in inglese.
    var etich = el("label", "ofm__filebtn", T.fotoElegir);
    etich.setAttribute("for", file.id);
    var nomeFile = el("p", "ofm__filenombre", "");
    var barra = el("div", "ofm__barra");
    var dentro = el("span");
    barra.appendChild(dentro);
    barra.hidden = true;
    gFoto.appendChild(file);
    gFoto.appendChild(etich);
    gFoto.appendChild(el("p", "ofm__ayuda", T.fotoAyuda));
    gFoto.appendChild(nomeFile);
    gFoto.appendChild(barra);
    file.addEventListener("change", function () {
      var f = file.files && file.files[0];
      if (!f) return;
      nomeFile.textContent = f.name || "";
      decir("");
      barra.hidden = false;
      dentro.style.width = "5%";
      reducir(f)
        .then(function (lista2) {
          return subir(
            {
              action: "photo",
              petId: pet.id,
              base64: lista2.base64,
              mimeType: lista2.mimeType,
              filename: f.name || "mascota.jpg"
            },
            function (p) {
              dentro.style.width = p + "%";
              decir(T.fotoSubiendo.replace("{n}", String(p)));
            }
          );
        })
        .then(function (r) {
          barra.hidden = true;
          if (!r || !r.ok || !r.pet) {
            decir(conCodigo(r && r.error) || T.errFoto, true);
            return;
          }
          // La imagen se vuelve a dibujar con la nueva. Si Shopify todavía no la ha
          // procesado (photoUrl null) se deja la que había: cambiarla por la inicial
          // haría pensar que la foto se ha perdido.
          var conFoto = {};
          Object.keys(r.pet).forEach(function (k) {
            conFoto[k] = r.pet[k];
          });
          conFoto.photoUrl = r.photoUrl || pet.photoUrl || null;
          conFoto.plans = pet.plans || [];
          refrescar(conFoto);
          dibujarModulo(conFoto);
          decir(T.fotoHecha);
        })
        .catch(function () {
          barra.hidden = true;
          decir(T.errFoto, true);
        });
    });
    panel.appendChild(gFoto);

    /* Quién es */
    var gQuien = el("section", "ofm__grupo");
    gQuien.appendChild(el("h3", "ofm__h2", T.quien));
    var campos = el("div", "ofm__campos");
    var cNombre = texto(pet.name);
    cNombre.maxLength = 60;
    var cPeso = texto(pet.weightKg, "text");
    cPeso.inputMode = "decimal";
    var cNac = texto(pet.birthdate, "date");
    cNac.max = new Date().toISOString().slice(0, 10);
    var cRaza = texto(pet.breed);
    var cSexo = seleccion(pet.sex || "", [
      { v: "", label: T.sexoNo },
      { v: "female", label: T.hembra },
      { v: "male", label: T.macho }
    ]);
    campos.appendChild(campo(T.nombre, cNombre));
    campos.appendChild(campo(T.peso, cPeso));
    campos.appendChild(campo(T.nacimiento, cNac));
    campos.appendChild(campo(T.sexo, cSexo));
    campos.appendChild(campo(T.raza, cRaza, true, T.razaAyuda));
    gQuien.appendChild(campos);
    panel.appendChild(gQuien);

    /* Cómo está. Los valores son los del store: medium y underweight, no "normal" ni
       "thin", que el metaobject rechaza. */
    var gComo = el("section", "ofm__grupo");
    gComo.appendChild(el("h3", "ofm__h2", T.como));
    var campos2 = el("div", "ofm__campos");
    var cAct = seleccion(pet.activityLevel || "medium", [
      { v: "low", label: T.actBaja },
      { v: "medium", label: T.actMedia },
      { v: "high", label: T.actAlta }
    ]);
    var cCuerpo = seleccion(pet.bodyCondition || "ideal", [
      { v: "underweight", label: T.cuerpoDelgado },
      { v: "ideal", label: T.cuerpoIdeal },
      { v: "overweight", label: T.cuerpoAlgo },
      { v: "obese", label: T.cuerpoObeso }
    ]);
    campos2.appendChild(campo(T.actividad, cAct));
    campos2.appendChild(campo(T.cuerpo, cCuerpo, false, T.cuerpoAyuda));
    gComo.appendChild(campos2);
    var lblEst = el("label", "ofm__check");
    var chk = document.createElement("input");
    chk.type = "checkbox";
    chk.checked = !!pet.neutered;
    lblEst.appendChild(chk);
    lblEst.appendChild(document.createTextNode(T.esterilizado));
    gComo.appendChild(lblEst);
    panel.appendChild(gComo);

    /* Alergias y necesidades: del catálogo, siempre. */
    var pAl = pastillas(opciones(VOCAB && VOCAB.allergens), pet.allergies, false, T.noPuede);
    var ayudaAl = el("p", "ofm__ayuda", T.noPuedeAyuda);
    var gAl = el("section", "ofm__grupo");
    gAl.appendChild(pAl);
    gAl.appendChild(ayudaAl);
    panel.appendChild(gAl);

    var pNec = null;
    if (VOCAB && VOCAB.needs && VOCAB.needs.length) {
      var gNec = el("section", "ofm__grupo");
      pNec = pastillas(opciones(VOCAB.needs), pet.needs, true, T.cuidar);
      gNec.appendChild(pNec);
      panel.appendChild(gNec);
    }

    var acciones = el("div", "ofm__acciones");
    var guardar = el("button", "ofm__btn", T.guardar);
    guardar.type = "button";
    var cerrar = el("button", "ofm__btn ofm__btn--claro", T.volver);
    cerrar.type = "button";
    cerrar.addEventListener("click", function () { dibujarFicha(pet); });
    guardar.addEventListener("click", function () {
      var peso = Number(String(cPeso.value).replace(",", "."));
      if (!cNombre.value.trim()) return decir(T.errNombre, true);
      if (!(peso > 0 && peso <= 120)) return decir(T.errPeso, true);
      guardar.disabled = true;
      decir("");
      llamar({
        action: "save",
        petId: pet.id,
        pet: {
          name: cNombre.value,
          weightKg: peso,
          birthdate: cNac.value,
          breed: cRaza.value,
          sex: cSexo.value,
          activityLevel: cAct.value,
          bodyCondition: cCuerpo.value,
          neutered: chk.checked,
          allergies: pAl.leer(),
          needs: pNec ? pNec.leer() : undefined
        }
      })
        .then(function (r) {
          guardar.disabled = false;
          // Sin `pet` no se ha escrito nada, diga lo que diga `ok`.
          if (!r || !r.ok || !r.pet) return decir(conCodigo(r && r.error), true);
          // I piani non tornano dal salvataggio: si tengono quelli che si avevano,
          // se no i tre numeri sparirebbero dalla ficha appena salvata.
          r.pet.plans = pet.plans || [];
          refrescar(r.pet);
          dibujarFicha(r.pet);
          decir(T.guardado);
        })
        .catch(function () {
          guardar.disabled = false;
          decir(T.errRed, true);
        });
    });
    acciones.appendChild(guardar);
    acciones.appendChild(cerrar);
    panel.appendChild(acciones);

    /* La ración sale de estos datos, pero la frecuencia de entrega vive en la
       suscripción y no se mueve sola. Decirlo aquí es más honesto que dejar que el
       cliente cambie el peso y siga recibiendo el saco con el ritmo de antes. */
    var nota = raiz.getAttribute("data-plan-note");
    if (nota && pet.subscriptionContractId) {
      var p = el("p", "ofm__ayuda ofm__notaplan", nota);
      panel.appendChild(p);
    }

    /* Dos pasos, y el segundo dice a quién. Un confirm() del navegador aquí no sirve:
       en el móvil sale fuera de contexto y la mitad de la gente lo acepta sin leerlo.
       El paso atrás tiene su propio botón, porque "toca otra vez" sin salida es una
       trampa para quien lo ha tocado sin querer. */
    var zonaBorrar = el("div", "ofm__zonaborrar");
    var borrar = el("button", "ofm__borrar", T.borrar);
    borrar.type = "button";
    borrar.addEventListener("click", function () {
      zonaBorrar.innerHTML = "";
      var si = el("button", "ofm__borrar ofm__borrar--si", T.borrarSeguro.replace("{name}", pet.name || ""));
      si.type = "button";
      var no = el("button", "ofm__btn ofm__btn--claro", T.borrarNo);
      no.type = "button";
      no.addEventListener("click", function () {
        zonaBorrar.innerHTML = "";
        zonaBorrar.appendChild(borrar);
        borrar.focus();
      });
      si.addEventListener("click", function () {
        si.disabled = true;
        llamar({ action: "delete", petId: pet.id })
          .then(function (r) {
            // Se comprueba QUÉ se ha borrado antes de quitarle una ficha de delante.
            if (!r || !r.ok || r.deletedId !== pet.id) {
              si.disabled = false;
              return decir(T.errBorrar, true);
            }
            cerrarPanel();
            quitarTarjeta(pet.id);
            decir(T.borrada);
          })
          .catch(function () {
            si.disabled = false;
            decir(T.errRed, true);
          });
      });
      zonaBorrar.appendChild(si);
      zonaBorrar.appendChild(no);
      si.focus();
    });
    zonaBorrar.appendChild(borrar);
    panel.appendChild(zonaBorrar);

    panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function cerrarPanel() {
    panel.hidden = true;
    panel.innerHTML = "";
    abierto = null;
    marcarAbierta(null);
  }

  /* ── La lista ────────────────────────────────────────────────────────────── */

  function numero(gid) {
    return String(gid || "").replace(/\D/g, "");
  }

  function tarjeta(pet) {
    var b = el("button", "ofm__card");
    b.type = "button";
    b.setAttribute("data-ofm-card", "");
    b.setAttribute("data-ofm-id", numero(pet.id));
    var foto = el("span", "ofm__foto");
    if (pet.photoUrl) {
      var img = document.createElement("img");
      img.src = pet.photoUrl;
      img.alt = "";
      img.loading = "lazy";
      foto.appendChild(img);
    } else {
      foto.appendChild(el("span", "ofm__inicial", (pet.name || "?").charAt(0).toUpperCase()));
    }
    var txt = el("span", "ofm__texto");
    txt.appendChild(el("span", "ofm__nombre", pet.name || ""));
    txt.appendChild(el("span", "ofm__linea", resumen(pet)));
    b.appendChild(foto);
    b.appendChild(txt);
    if ((pet.plans || []).length) b.appendChild(el("span", "ofm__plan", "Plan"));
    b.addEventListener("click", function () {
      abrir(pet.id);
    });
    return b;
  }

  function marcarAbierta(id) {
    Array.prototype.forEach.call(lista.querySelectorAll("[data-ofm-card]"), function (c) {
      c.setAttribute("aria-expanded", String(id != null && c.getAttribute("data-ofm-id") === String(id)));
    });
  }

  function quitarTarjeta(gid) {
    ANIMALES = ANIMALES.filter(function (p) {
      return p.id !== gid;
    });
    var c = lista.querySelector('[data-ofm-id="' + numero(gid) + '"]');
    if (c) c.parentNode.removeChild(c);
  }

  function refrescar(pet) {
    if (!pet) return;
    var i = -1;
    ANIMALES.forEach(function (p, k) {
      if (p.id === pet.id) i = k;
    });
    if (i === -1) ANIMALES.push(pet);
    else ANIMALES[i] = pet;

    var vieja = lista.querySelector('[data-ofm-id="' + numero(pet.id) + '"]');
    var nueva2 = tarjeta(pet);
    if (vieja) lista.replaceChild(nueva2, vieja);
    else lista.appendChild(nueva2);
    marcarAbierta(abierto);
    var vacio = lista.querySelector("[data-ofm-vacio]");
    if (vacio) vacio.parentNode.removeChild(vacio);
  }

  function abrir(gid) {
    var pet = ANIMALES.filter(function (p) {
      return p.id === gid;
    })[0];
    if (!pet) return decir(T.cargando);
    abierto = numero(gid);
    marcarAbierta(abierto);
    dibujarFicha(pet);
  }

  /* Las tarjetas ya están en el HTML, pintadas por Liquid: no se vuelven a dibujar,
     solo se les engancha el clic en cuanto se sabe a qué animal corresponde cada una. */
  function engancharLiquid() {
    Array.prototype.forEach.call(lista.querySelectorAll("[data-ofm-card]"), function (c) {
      var num = c.getAttribute("data-ofm-id");
      c.addEventListener("click", function () {
        if (!cargado) return decir(T.cargando);
        var pet = ANIMALES.filter(function (p) {
          return numero(p.id) === num;
        })[0];
        if (pet) abrir(pet.id);
        else decir(T.cargando);
      });
    });
  }

  function nueva() {
    if (!cargado) return decir(T.cargando);
    if (ANIMALES.length >= TOPE) return decir(T.errTope, true);
    cerrarPanel();
    panel.hidden = false;
    panel.appendChild(el("h2", "ofm__h2", T.nueva));
    var campos = el("div", "ofm__campos");
    var cNombre = texto("");
    cNombre.maxLength = 60;
    var cPeso = texto("", "text");
    cPeso.inputMode = "decimal";
    var cEspecie = seleccion("dog", [
      { v: "dog", label: T.perro },
      { v: "cat", label: T.gato }
    ]);
    campos.appendChild(campo(T.nombre, cNombre));
    campos.appendChild(campo(T.peso, cPeso));
    campos.appendChild(campo(T.especie, cEspecie, true));
    panel.appendChild(campos);
    var acc = el("div", "ofm__acciones");
    var crear = el("button", "ofm__btn", T.crear);
    crear.type = "button";
    var cancelar = el("button", "ofm__btn ofm__btn--claro", T.cerrar);
    cancelar.type = "button";
    cancelar.addEventListener("click", cerrarPanel);
    crear.addEventListener("click", function () {
      var peso = Number(String(cPeso.value).replace(",", "."));
      if (!cNombre.value.trim()) return decir(T.errNombre, true);
      if (!(peso > 0 && peso <= 120)) return decir(T.errPeso, true);
      crear.disabled = true;
      llamar({
        action: "create",
        pet: { name: cNombre.value, weightKg: peso, species: cEspecie.value }
      })
        .then(function (r) {
          crear.disabled = false;
          if (!r || !r.ok || !r.pet) return decir(conCodigo(r && r.error), true);
          refrescar(r.pet);
          abrir(r.pet.id);
          decir(T.creada);
        })
        .catch(function () {
          crear.disabled = false;
          decir(T.errRed, true);
        });
    });
    acc.appendChild(crear);
    acc.appendChild(cancelar);
    panel.appendChild(acc);
    panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
    cNombre.focus();
  }

  if (btnNueva) btnNueva.addEventListener("click", nueva);
  engancharLiquid();

  /* La lista de verdad: identificadores, campos que el metafield no da, y el
     vocabulario del catálogo. Hasta que no llega no se puede abrir nada. */
  fetch(URL_PETS, { headers: { Accept: "application/json" }, redirect: "error" })
    .then(function (r) {
      return r.json();
    })
    .then(function (d) {
      if (!d || !d.ok) return;
      ANIMALES = d.pets || [];
      VOCAB = d.vocabulary || null;
      if (d.max) TOPE = d.max;
      cargado = true;
      // Si apre la prima: la colonna di destra vuota sembra una pagina a meta',
      // e chi arriva qui ha quasi sempre un animale solo.
      if (ANIMALES.length) abrir(ANIMALES[0].id);
    })
    .catch(function () {
      /* Sin la lista las tarjetas siguen ahí y se leen: solo no se abren, y al
         tocarlas lo dicen en vez de no hacer nada. */
    });
})();
